import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/track`;

export const VisitTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const q = new URLSearchParams(search);
    const utm = ["utm_source", "utm_medium", "utm_campaign"].reduce((o, k) => {
      const v = q.get(k) || sessionStorage.getItem(k);
      if (q.get(k)) sessionStorage.setItem(k, q.get(k));
      return v ? { ...o, [k]: v } : o;
    }, {});
    const first = !sessionStorage.getItem("oz_seen");
    sessionStorage.setItem("oz_seen", "1");
    fetch(API, { method: "POST", keepalive: true, headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: pathname, referrer: first ? document.referrer : "", ...utm }) }).catch(() => {});
  }, [pathname, search]);
  return null;
};
